export default __webpack_public_path__ + "static/media/About-3.54fe67b4.jpg";